export const DropdownValues = {
    projectType: 'az_iv_projecttype',
    disease: 'az_iv_disease',
    brands: 'az_iv_brands',
    targetGroup: 'az_iv_targetgroup',
    regions: 'az_iv_regions',
    researchMethod: 'az_iv_researchmethod',
    supplier: 'az_iv_supplier',
    publisedYear: 'az_iv_publishedyear'
}